import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Constant} from '../../global/util/Constant';
import {GeolocationIofesign} from '../model/GeolocationIofesign';
import {Observable} from 'rxjs';
import {Headers} from '../../global/util/Headers';

@Injectable({
    providedIn: 'root'
})
export class GeolocationService {
    private url = Constant.ROOT_API_V1.concat('/public/geolocation');

    constructor(private http: HttpClient) {
    }

    public save(geolocation: GeolocationIofesign): Observable<any> {
        return this.http.post(this.url, JSON.stringify(geolocation), Headers.contentType);
    }
}
